export default () => {
    let backto = "";

    if (ajax_var.redirect_to) {
        backto = "?backto=" + ajax_var.redirect_to;
    }

    return backto;
}
